import React from 'react';
import ArticleSearchContainer from '../../containers/ArticleSearchContainer';

const KeywordSearcher = () => {
  const { word, setWord, search } = ArticleSearchContainer.useContainer();
  return (
    <div>
      <h5>フリーワード</h5>
      <div className="searchConditionWrap">
        <div className="selectConditions">
          <input
            className=""
            type="text"
            value={word}
            onChange={e => setWord(e.target.value)}
          />
        </div>
      </div>
      <button className="p_btn isMain" onClick={() => search()}>検索</button>
    </div>
  )
};

export default KeywordSearcher;